ngPrice.$inject = [];

/* @ngInject */
function ngPrice() {
    // Usage:
    //
    // Creates:
    //
    var directive = {
        link: link,
        restrict: 'A',
        scope: {
            value: '=ngPrice',
            round: '@round',
            colorDisabled: '@colorDisabled',
        }
    };
    return directive;

    function link(scope, element) {
        scope.$watch('value', function (price) {
            //price = parseFloat(price).toFixed(2);

            if (scope.round) {
                price = Math.round(price);
            }

            if (isNaN(price) || !isFinite(price)) {
                element.html('-').css('color', 'gray');
                return;
            }

            var formatted = (price).toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: scope.round ? 0 : 2,
            });

            element
                .html(formatted);
            if (!scope.colorDisabled) {
                element.css('color', (price < 0) ? 'red' : 'green');
            }
        });
    }
}

export default ngPrice;